import React, { useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { SearchIcon } from 'tdesign-icons-react';
import { Input } from 'tdesign-react';
import Highlighter from 'react-highlight-words';
import { doBuried } from '@/services/buriedService';

function Left({ clusters, onSelect, current }) {
  const [filter, setFilter] = useState('');
  const searchWords = filter.split(/\s/).filter((word) => word);

  const onFocus = () => {
    doBuried({ eventId: 'RESOURCE_DETAIL_HOST_TERMINAL_FOCUS' });
  };

  return (
    <Root>
      <Title>集群列表</Title>
      <Input
        style={{ margin: '0 20px 12px', width: 'auto' }}
        onChange={setFilter}
        placeholder='请输入集群'
        clearable
        onFocus={onFocus}
        suffixIcon={<SearchIcon />}
      />
      <Content className='narrow-scrollbar'>
        {clusters
          .filter((item) => item.name.toLowerCase().indexOf(filter.toLowerCase()) > -1)
          .map((item) => (
            <Item onClick={() => onSelect(item.id)} active={current === item.id} key={item.id}>
              <Highlighter
                activeIndex={-1}
                highlightStyle={{
                  color: 'var(--td-brand-color-7)',
                  fontWeight: 'bold',
                  background: 'transparent',
                }}
                searchWords={searchWords}
                textToHighlight={item.name}
              />
            </Item>
          ))}
      </Content>
    </Root>
  );
}

export default connect((state) => ({
  clusters: state.resource.clusters.filter((item) => item.type === 0), // 仅主机类型
}))(Left);

const Root = styled.div`
  width: 240px;
  padding: 24px 0 24px 1px;
`;

const Title = styled.div`
  color: var(--td-font-gray-1);
  font-size: 14px;
  padding: 0 24px;
  font-weight: bold;
  margin-bottom: 10px;
`;

const Content = styled.div`
  /* height: calc(100vh - 276px);
  overflow-y: auto; */
`;

const Item = styled.div`
  height: 33px;
  line-height: 33px;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 24px;
  cursor: pointer;
  position: relative;
  ${(props) =>
    props.active &&
    ` 
      background: #F7F8FA;
      color: var(--td-brand-color-7);
      font-weight: bold;
      border-right: 2px solid var(--td-brand-color-7);
    `}
`;
